import PropTypes from 'prop-types';
import {useHistory, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';

import {Icon} from 'front-onceforall-core';

import {USER_REQUEST_TYPES} from '../../utils/constant';

import DashboardMessage from '../dashboardMessage';
import InformationMessage from '../informationMessage';
import DossierCountrySelector from '../dossierCountrySelector';
import DiscoverBdrBox from '../DiscoverBdrBox';
import ToggleBdrBoxButton from '../DiscoverBdrBox/ToggleBdrBoxButton';

import ContentWrapper from './ContentWrapper';
import {useDossierCountry} from './OrganisationDashboardContainer';

function OrganisationDashboardView({countries, onCountryChange}) {
  const organisation = useSelector(state => state.organisation);
  const dossierCountry = useDossierCountry();
  const history = useHistory();
  const location = useLocation();

  return (
    <>
      <div className="mt-4 mb-5 flex-container space-between">
        <h1 className="m-0">{organisation.fullName}</h1>
        <div className='row'>
          <ToggleBdrBoxButton/>
          {organisation.enabled &&
          <DossierCountrySelector
            onChange={onCountryChange}
            value={dossierCountry || ''}
            countries={countries}
          />
          }
        </div>
      </div>

      <InformationMessage/>

      <DiscoverBdrBox/>

      {organisation.enabled ?
        <ContentWrapper/> :
        <DashboardMessage
          icon={<div className="active mb-5"><Icon
            icon="error"
            size={80}
          /></div>}
          title="dashboard.deactivated.title"
          message="dashboard.deactivated.message"
          buttonLabel="dashboard.deactivated.action"
          onClickButton={() => history.push(`${location.pathname}?contact=${USER_REQUEST_TYPES.MY_OFFER}`)}
        />
      }
    </>
  );
}

OrganisationDashboardView.propTypes = {
  countries: PropTypes.array.isRequired,
  onCountryChange: PropTypes.func.isRequired
};

export default OrganisationDashboardView;
